import apiClient from '../../../api/apiClient';
import { MANAGER_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = MANAGER_REST_API_BASE_URL;

export const getAllAttachments = () =>
  apiClient.get(REST_API_BASE_URL + '/attachments');

export const saveAttachment = (attachment) =>
  apiClient.post(REST_API_BASE_URL + '/attachment', attachment);

export const getAttachment = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/attachment/${id}`);

export const updateAttachment = (id, attachment) =>
  apiClient.put(`${REST_API_BASE_URL}/attachment/${id}`, attachment);

export const deleteAttachment = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/attachment/${id}`);

export const uploadFile = (formData) =>
  apiClient.post(`${REST_API_BASE_URL}/upload`, formData);

export const getFile = (filename) =>
  apiClient.get(`${REST_API_BASE_URL}/file/${filename}`, {
    responseType: 'blob', // Receive response as Blob
    headers: {
      Accept: 'image/png, image/jpg, image/tiff, application/pdf', // Specify acceptable media types
    },
  });
